/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:3e094979-6d2a-4638-a2ea-28f77537c6c2",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_afrcLSsh4",
    "aws_user_pools_web_client_id": "1tbodogpp11hvfdicul8vgnquh",
    "oauth": {
        "domain": "poppyrecipebuilder-staging.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://recipebuilder-dev.poppyfloral.io/,https://www.recipe-builder.poppyflowers.com/",
        "redirectSignOut": "http://localhost:3000/,https://recipebuilder-dev.poppyfloral.io/,https://www.recipe-builder.poppyflowers.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
